import { render, staticRenderFns } from "./ApplicationFlowCheckboxQuestion.vue?vue&type=template&id=7070e42c&scoped=true&"
import script from "./ApplicationFlowCheckboxQuestion.vue?vue&type=script&lang=js&"
export * from "./ApplicationFlowCheckboxQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFlowCheckboxQuestion.vue?vue&type=style&index=0&id=7070e42c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7070e42c",
  null
  
)

export default component.exports